import { useState } from 'react';

export function useSelectWithOther<T extends { id: string }>(options: T[], getLabel: (opt: T) => string, initialValue: string) {
  const initialMatch = options.find((option) => getLabel(option) === initialValue);

  const [selectedId, setSelectedId] = useState<string | undefined>(() => {
    if (initialMatch) return initialMatch.id;
    if (initialValue) return 'other';
    return undefined;
  });

  const [otherValue, setOtherValue] = useState<string>(() => {
    return !initialMatch && initialValue ? initialValue : '';
  });

  const resolveValue = (id: string) => {
    const selected = options.find((option) => option.id === id);
    if (!selected) return '';
    return selected.id === 'other' ? otherValue : getLabel(selected);
  };

  return {
    selectedId,
    setSelectedId,
    otherValue,
    setOtherValue,
    isOther: selectedId === 'other',
    resolveValue,
  };
}
